module.exports = __webpack_public_path__ + "static/media/otp_icon.6f9f1c6a.svg";